import axios from "axios";

const instance = axios.create({
    baseURL: "/api",
});

instance.interceptors.request.use(
    function (config) {
        const accessToken = JSON.parse(window.localStorage.getItem("access_token"));

        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
            config.headers.Accept = "application/json";
            config.headers["Content-Type"] = "application/x-www-form-urlencoded";
        }

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        const originalRequest = error.config;

        if (error.config.url === '/refresh' && error.response.status === 401) {
            localStorage.removeItem("user");
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            window.location.href = '/';
        }

        if (
            error.response.status === 401 &&
            !originalRequest._retry &&
            error.config.url !== '/login'
        ) {
            originalRequest._retry = true;

            await refreshAccessToken();

            return instance(originalRequest);
        }

        return Promise.reject(error);
    }
);

async function refreshAccessToken() {
    const refreshToken = JSON.parse(window.localStorage.getItem("refresh_token"));

    try {
        const response = await instance.post("/refresh", {
            token: refreshToken,
        });

        if (response.status === 200) {
            localStorage.setItem(
                "access_token",
                JSON.stringify(response.data.data.accessToken)
            );
            localStorage.setItem(
                "refresh_token",
                JSON.stringify(response.data.data.refreshToken)
            );
        }
    } catch (error) {
        return Promise.reject(error);
    }
}

export {instance as AXIOS};
